export default {
    init() {
        /** Initialising the swiper for testimonials if on mobile or tablet. */
            document.querySelectorAll('.testimonials__swiper-container').forEach(testimonial => {
                const WIDTH = 400;
                const MOBILE_WIDTH = 335;
                const MARGIN = 20;

                let initial_width = (window.innerWidth <= 479) ? MOBILE_WIDTH + (MARGIN * 2) : WIDTH + (MARGIN * 2);

                let swiper = new Swiper(testimonial, {
                    width: initial_width,
                    spaceBetween: 20,
                    loop: false,
                    init: false,
                    on: {
                        init: function () {
                            console.log("Inititalized")
                        },
                        resize: function (swiper) {
                            if (window.innerWidth <= 479) {
                                swiper.width = MOBILE_WIDTH + (MARGIN * 2);
                            } else {
                                swiper.width = WIDTH + (MARGIN * 2);
                            }
                        }
                    }
                });

                if(window.innerWidth <= 1300) {
                    swiper.init();
                }

                window.addEventListener('resize', () => {
                    if(window.innerWidth <= 1300) {
                        swiper.init();
                    }
                })
            });
    }
}